module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section o-section__max-w c-form--payment",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "c-text-section"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Thank you.")]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullDetails.payByBankDeposit),
      expression: "fullDetails.payByBankDeposit"
    }]
  }, [_c('div', {
    staticClass: "c-checkout__deposit",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("\n                Please make your payment directly into our bank account, use your OrderID as Payment Reference.\n                "), _c('br'), _vm._v("\n                Artful Dodgers Ltd - ANZ\n                "), _c('br'), _vm._v("\n                06-0601-0777165-01\n                 \n                Order: " + _vm._s(_vm.id) + "\n                "), _c('br'), _vm._v("\n                Once your payment as been recieved we will process your order and email you a reciept.\n                "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartContents.length == 1),
      expression: "cartContents.length == 1"
    }]
  }, [_vm._v("This item is")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartContents.length > 1),
      expression: "cartContents.length > 1"
    }]
  }, [_vm._v("These items are")]), _vm._v(" \n                made to order and will will be dispatched within 4 weeks.\n            ")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullDetails.payByBankDeposit),
      expression: "!fullDetails.payByBankDeposit"
    }]
  }, [_c('div', {
    staticClass: "c-checkout__deposit",
    staticStyle: {
      "line-height": "28px"
    }
  }, [_vm._v("\n                Your order (#" + _vm._s(_vm.id) + ") has been recieved and we have emailed you a reciept.\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartContents.length == 1),
      expression: "cartContents.length == 1"
    }]
  }, [_vm._v("This item is")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartContents.length > 1),
      expression: "cartContents.length > 1"
    }]
  }, [_vm._v("These items are")]), _vm._v(" \n                made to order and will will be dispatched within 4 weeks.\n                Once the item is shipped we will email you an update and tracking number\n            ")])])]), _vm._v(" "), _c('section', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "c-checkout"
  }, [_c('p', {
    staticClass: "c-text__title"
  }, [_vm._v("Customer information")]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.name))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.email))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text",
    attrs: {
      "ng-if": "engravingText != ''"
    }
  }, [_vm._v(_vm._s(_vm.fullDetails.engravingText))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address.company))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address.street))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address.street2))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address.state) + " " + _vm._s(_vm.fullDetails.address.zip))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address.city))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address.country))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "ng-if": "fullDetails.billingAndShipping!"
    }
  }, [_c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address2.company))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address2.street))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address2.street2))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address2.state) + " " + _vm._s(_vm.fullDetails.address2.zip))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address2.city))]), _vm._v(" "), _c('p', {
    staticClass: "c-text__text"
  }, [_vm._v(_vm._s(_vm.fullDetails.address2.country))])])]), _vm._v(" "), _c('div', {
    staticClass: "c-checkout"
  }, [_c('div', {
    staticClass: "c-checkout__cart"
  }, [_vm._l((_vm.cartContents), function(ring, index) {
    return _c('li', {
      key: ring.id,
      staticClass: "c-cart__item"
    }, [_c('img', {
      staticClass: "c-cart__image",
      attrs: {
        "src": ring.ring.variations[ring.ring.variationIndex].images[0].url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-cart__item-details"
    }, [_c('p', {
      staticClass: "c-cart__detail"
    }, [_vm._v("Metal: " + _vm._s(ring.ring.variations[ring.ring.variationIndex].variation_name))]), _vm._v(" "), _c('span', {
      staticClass: "c-cart__detail"
    }, [_vm._v("Size: " + _vm._s(ring.selectedSize.text))])]), _vm._v(" "), _c('div', {
      staticClass: "c-cart__item-details c-cart__item-details--al-m"
    }, [_c('p', {
      staticClass: "c-cart__price"
    }, [_vm._v(_vm._s(ring.ring.variations[ring.ring.variationIndex].price[_vm.$store.state.currency].formatted))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "c-cart__totals"
  }, [_c('div', {
    staticClass: "c-cart__subTotal"
  }, [_c('span', {
    staticClass: "c-cart__subTotal-total"
  }, [_vm._v("TOTAL ")]), _vm._v(" "), _c('span', {
    staticClass: "c-cart__subTotal-currency"
  }, [_vm._v("(" + _vm._s(_vm.$store.state.currency) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "c-cart__subTotal-price"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency != 'EUR' && _vm.$store.state.currency != 'GBP'),
      expression: "$store.state.currency != 'EUR' && $store.state.currency != 'GBP'"
    }]
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency == 'EUR'),
      expression: "$store.state.currency == 'EUR'"
    }]
  }, [_vm._v("€")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.currency == 'GBP'),
      expression: "$store.state.currency == 'GBP'"
    }]
  }, [_vm._v("£")]), _vm._v("\n                            " + _vm._s(_vm.total) + "\n                        ")])])]), _vm._v(" "), _c('p', {
    staticClass: "c-checkout__text"
  }, [_vm._v("Shipping is free on all orders")])], 2)]), _vm._v(" "), _c('router-link', {
    staticClass: "c-btn c-btn__link c-btn__link--back",
    staticStyle: {
      "margin-top": "32px !important"
    },
    attrs: {
      "to": "/shop"
    }
  }, [_vm._v("Continue shopping")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a70303","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderComplete.vue
// module id = 401
// module chunks = 0